// autoReviewConfig.js — harness-audit 07-13 (EPIC-CLASSIFY-1).
// @arch:pure-engine
//
// Monta a config `autoReview` passada ao runLocalAgentLoop, mantendo a lógica FORA da
// região dp-loc guardada do SessionWorkspace (que é zero-headroom). Puro: recebe o
// snapshot de permissões e o classificador já construído (ou null).

/**
 * @param {{enabled?: boolean, policy?: any}|null} permissions  snapshot de .apolo/permissions.json
 * @param {Function|null} classify  classificador SUBORDINADO já construído (opts.classify), ou null (determinístico)
 * @param {object|null} e6  harness-uplift-r2 E6 hooks (buildE6Hooks() — injetado; DI mantém este builder puro)
 * @returns {{enabled: boolean, policy: any, opts?: {classify: Function}, e6?: object}|null}
 */
export function buildAutoReviewConfig(permissions, classify = null, e6 = null) {
  if (!permissions?.enabled) return null;
  const cfg = { enabled: true, policy: permissions.policy };
  if (typeof classify === 'function') cfg.opts = { classify };
  // E6: carry the flag-gated checks/notes/continue hooks on the config when any is on.
  if (e6 && (e6.checksEnabled || e6.notesEnabled || e6.continueEnabled)) cfg.e6 = e6;
  return cfg;
}
